import { openAccordian } from "#scripts/accordian";

export default () => {
	if (window.location.hash) {
		goToHash();
	}
	addEventListener("hashchange", (event) => {
		goToHash();
	});
};
const goToHash = () => {
	let scrollToTop = 0;
	const hashElement = window.location.hash.slice(1);
	const elm = document.getElementById(hashElement);

	const scrollToElement = (element) => {
		scrollToTop = element.getBoundingClientRect().top + document.documentElement.scrollTop;
		window.scrollTo(0, scrollToTop);
	};

	const handleAccordian = (element) => {
		let contentElm = element.querySelector(".accordian-content") || element.parentNode.querySelector(".accordian-content");
		if (contentElm?.dataset?.scrolltoaction === "openaccordian") {
			openAccordian(element.id);
		}
	};

	if (elm && elm.offsetWidth > 0 && elm.offsetHeight > 0) {
		scrollToElement(elm);
		if (elm.classList.contains("accordian")) {
			handleAccordian(elm);
		}
	} else {
		const parentWithClass = elm?.closest('.accordian');
		if (parentWithClass) {
			scrollToElement(parentWithClass);
			handleAccordian(parentWithClass);
		}
		if (elm && elm.offsetHeight > 0) {
			scrollToElement(elm);
		}
	}

	// *********************************************************** */
	// code to handle nested accordians (not workin/not finnised)
	// *********************************************************** */

	// let scrollToTop = 0;
	// const hashElement = window.location.hash.slice(1);
	// const elm = document.getElementById(hashElement);

	// const scrollToElement = (element) => {
	// 	scrollToTop = element.getBoundingClientRect().top + document.documentElement.scrollTop;
	// 	window.scrollTo(0, scrollToTop);
	// };

	// const handleAccordian = (element) => {
	// 	let contentElm = element.querySelector(".accordian-content") || element.parentNode.querySelector(".accordian-content");
	// 	if (contentElm?.dataset?.scrolltoaction === "openaccordian") {
	// 		openAccordian(element.id);
	// 	}
	// };

	// const openNestedAccordians = (element) => {
	// 	let currentElement = element;
	// 	while (currentElement) {
	// 		if (currentElement.classList.contains("accordian")) {
	// 			handleAccordian(currentElement);
	// 		}
	// 		currentElement = currentElement.closest('.accordian');
	// 	}
	// };

	// if (elm) {
	// 	if (elm.offsetWidth > 0 && elm.offsetHeight > 0) {
	// 		scrollToElement(elm);
	// 		openNestedAccordians(elm);
	// 	} else {
	// 		const parentWithClass = elm.closest('.accordian');
	// 		if (parentWithClass) {
	// 			scrollToElement(parentWithClass);
	// 			openNestedAccordians(parentWithClass);
	// 		}
	// 		if (elm.offsetHeight > 0) {
	// 			scrollToElement(elm);
	// 		}
	// 	}
	// }
};
